import {
	type NodeViewComponentProps,
	useEditorEffect,
	useEditorEventCallback,
} from "@handlewithcare/react-prosemirror";
import cx from "classnames";
import { forwardRef, useState } from "react";

import { CheckmarkIcon } from "@moment/icons";
import { makeTextCellDefaultToDOMAttrs } from "@moment/prosemirror-utils";

export const TODO_ITEM_CHECKBOX_CLASS = "to-do-item-checkbox";

export const ToDoItem = forwardRef<HTMLDivElement, NodeViewComponentProps>(function ToDoItem(
	{ nodeProps, children, ...props },
	ref
) {
	const { node, getPos } = nodeProps;
	const { class: className, attrs } = makeTextCellDefaultToDOMAttrs(
		node,
		"p-0 list-none flex items-start space-x-2"
	);

	const [editable, setEditable] = useState(false);
	useEditorEffect((view) => setEditable(view.editable), []);

	const onToggle = useEditorEventCallback((view) => {
		if (!view.editable) {
			return;
		}

		const status = node.attrs["status"] === "completed" ? "to do" : "completed";
		const tr = view.state.tr;

		tr.setNodeAttribute(getPos(), "status", status);

		view.dispatch(tr);
		view.focus();
	});

	return (
		<div
			ref={ref}
			{...props}
			{...attrs}
			className={className}
			data-node-type="to_do_item"
			data-status={node.attrs["status"]}
			data-indent={node.attrs["indent"]}
			data-text-cell={node.attrs["id"]}
		>
			<button
				type="button"
				className={cx(
					TODO_ITEM_CHECKBOX_CLASS,
					"border-2",
					"focus:ring-4",
					"ring-default",
					"h-4",
					"w-4",
					"mt-1",
					"shrink-0",
					"rounded",
					{
						"border-primary": node.attrs["status"] !== "completed",
						"bg-brand border-brand": node.attrs["status"] === "completed",
						"hover:border-primary-hover": editable,
						"focus:border-primary-focus": editable,
						"active:border-primary-active": editable,
					}
				)}
				disabled={!editable}
				contentEditable={false}
				onClick={onToggle}
			>
				{node.attrs["status"] === "completed" && (
					<CheckmarkIcon className="w-full h-full text-fixed-light-default" />
				)}
			</button>
			<div className="todo-content [&>p]:m-0 grow">{children}</div>
		</div>
	);
});
